module.exports = __webpack_public_path__ + "static/media/benifit-bg-min.4270102e.jpg";